/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Security category classification for this detection
 * @export
 */
export const ControlCategory3 = {
    OtherDiagnostic: 'OTHER__DIAGNOSTIC',
    OtherInformationalEvent: 'OTHER__INFORMATIONAL_EVENT',
    OtherWarning: 'OTHER__WARNING',
    OtherUnknown: 'OTHER__UNKNOWN',
    OtherDeception: 'OTHER__DECEPTION',
    OtherCustomDetection: 'OTHER__CUSTOM_DETECTION',
    CloudInvocation: 'CLOUD__INVOCATION',
    CloudDiscovery: 'CLOUD__DISCOVERY',
    CloudDataTransfer: 'CLOUD__DATA_TRANSFER',
    CloudPersistence: 'CLOUD__PERSISTENCE',
    EndpointDiscovery: 'ENDPOINT__DISCOVERY',
    EndpointExecution: 'ENDPOINT__EXECUTION',
    EndpointLiveOffTheLand: 'ENDPOINT__LIVE_OFF_THE_LAND',
    EndpointNuisance: 'ENDPOINT__NUISANCE',
    EndpointMalwareDiscovery: 'ENDPOINT__MALWARE_DISCOVERY',
    EndpointMalwareExecution: 'ENDPOINT__MALWARE_EXECUTION',
    EndpointLateStage: 'ENDPOINT__LATE_STAGE',
    EndpointPersistence: 'ENDPOINT__PERSISTENCE',
    EndpointRemoteManagement: 'ENDPOINT__REMOTE_MANAGEMENT',
    EndpointLateralMovement: 'ENDPOINT__LATERAL_MOVEMENT',
    EndpointImpact: 'ENDPOINT__IMPACT',
    EndpointEvasion: 'ENDPOINT__EVASION',
    EndpointExploitation: 'ENDPOINT__EXPLOITATION',
    EndpointSimulation: 'ENDPOINT__SIMULATION',
    EndpointPlannedChange: 'ENDPOINT__PLANNED_CHANGE',
    IdentityLogin: 'IDENTITY__LOGIN',
    IdentityRejectedMfa: 'IDENTITY__REJECTED_MFA',
    IdentityDiscovery: 'IDENTITY__DISCOVERY',
    IdentityBruteForce: 'IDENTITY__BRUTE_FORCE',
    IdentityPublicCredentialExposure: 'IDENTITY__PUBLIC_CREDENTIAL_EXPOSURE',
    IdentityPrivateCredentialExposure: 'IDENTITY__PRIVATE_CREDENTIAL_EXPOSURE',
    IdentityPersistence: 'IDENTITY__PERSISTENCE',
    IdentityAccountCompromise: 'IDENTITY__ACCOUNT_COMPROMISE',
    IdentitySimulation: 'IDENTITY__SIMULATION',
    NetworkInboundConnection: 'NETWORK__INBOUND_CONNECTION',
    NetworkOutboundConnection: 'NETWORK__OUTBOUND_CONNECTION',
    NetworkPhishing: 'NETWORK__PHISHING',
    NetworkNoisy: 'NETWORK__NOISY',
    NetworkDiscovery: 'NETWORK__DISCOVERY',
    EmailPhishing: 'EMAIL__PHISHING',
    EmailPhishingReported: 'EMAIL__PHISHING_REPORTED',
    EmailEvasion: 'EMAIL__EVASION',
    EmailMalware: 'EMAIL__MALWARE',
    EmailMaliciousLink: 'EMAIL__MALICIOUS_LINK',
    EmailGraymail: 'EMAIL__GRAYMAIL',
    EmailSpam: 'EMAIL__SPAM',
    EmailBusinessEmailCompromise: 'EMAIL__BUSINESS_EMAIL_COMPROMISE',
    DataDataTransfer: 'DATA__DATA_TRANSFER',
    DataDataShare: 'DATA__DATA_SHARE',
    PosturePosture: 'POSTURE__POSTURE',
    PostureHealth: 'POSTURE__HEALTH'
} as const;
export type ControlCategory3 = typeof ControlCategory3[keyof typeof ControlCategory3];


export function ControlCategory3FromJSON(json: any): ControlCategory3 {
    return ControlCategory3FromJSONTyped(json, false);
}

export function ControlCategory3FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCategory3 {
    return json as ControlCategory3;
}

export function ControlCategory3ToJSON(value?: ControlCategory3 | null): any {
    return value as any;
}

